import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="47.92 25.07 47.92 47.83 29.37 47.9 19.33 38.5 32.45 9.81 47.92 25.07"
  />
);

export let ArtworkWeirdBarbie = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.weirdBarbie}
    renderShadow={renderShadow}
  >
    <g>
      <path
        style={{ fill: '#eddade' }}
        d="M10.81,24.75c1.9-2.84.87-3.03.81-5.86-.05-2.21,1.09-5.27,2.76-6.73,2.08-1.82,4.74-2.83,7.47-3.41,3.26-.69,7.13.45,10.06,2,3.75,2,5.35,6.57,3.9,10.48-.29.77-.24,1.87-.32,2.69-.19,1.83.57,2.27,1.47,4.29-1.55.29-1.61,2.06-.52,3.74-.43-.04-1.14-.11-1.57-.16-.17,1.49-1.42,3.66-2.08,5.02-1.03-1.08-10.62.34-15.19.55-4.19.19-3.21-1.98-4.97-5.94-.1.57-.5.95-1.51,1.49,1.24-2.75.9-7.84-.3-8.14Z"
      />
      <path
        style={{ fill: '#ffc5ad' }}
        d="M24,40.96c-3.4,0-8.59-5.58-9.28-9.28-.27-1.48-.34-7.38-.34-7.38,0-5.89,4.31-10.66,9.62-10.66h0c5.31,0,9.62,4.77,9.62,10.66,0,0-.07,5.9-.34,7.38-.69,3.71-5.88,9.28-9.28,9.28Z"
      />
      <path
        style={{
          fill: 'none',
          strokeMiterlimit: 10,
          stroke: '#d9a996',
        }}
        d="M16.97,24.7c.88-.81,3.18-2.2,4.41-2.12.52.04,1.44.78,1.71,1.34s.58,1.27.19,2.25c-.33.82-.72,1.53-1.14,2.15s-4.28,2.6-5.29,2.26c-1.3-.44-1.04-4.8.13-5.89Z"
      />
      <path
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
          fill: 'none',
          stroke: '#a7799e',
        }}
        d="M19.58,21.71c1.19-1.02,1.88-1.79,1.99-1.79.85.03,1.53.61,2.18,1.1.63.47,1.3.88,2.02,1.23.38.18.8.36,1.23.33s-.2-2.11-.17-2.5c.15.04,1.38,1.88,1.53,1.92.15-.46.39-.9.7-1.3.08-.1.16-.2.29-.24.21-.08.44.02.65.1.4.16.83.27,1.26.33.3.04.66.03.84-.19.22-.27,0-.67-.3-.87"
      />
      <path
        style={{
          stroke: '#ee5f9b',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
          fill: 'none',
        }}
        d="M24.03,22.84c.26.01,1.03,1.43,1.41.85.47-.72-.39-3.62-.28-3.68.32-.18,3.11,3.3,4.15,3.05.21-.05.35-3.17.53-3.34.69-.67,1.07,1.28,1.62,1.91.14.16.32.34.54.32.19-.02.33-.2.44-.36"
      />
      <path
        style={{
          stroke: '#eddade',
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
          fill: '#fee9ee',
        }}
        d="M41.45,19.75c-.42-2.85-2.66-4.61-4.12-5.08-1.34-.43-2.72.22-4.11,1.29.56-.53,2.58-3.82,2.43-4.07-.66-1.1-1.54-2.61-2.87-3.56-2.36,1.34-3.36,4.6-3.76,7.25.46-2.86-.88-5.8-.84-8.7-.77-.34-4.71-.49-5.54-.56.59.97.56,1.56.56,1.56,0,0-.79-.47-1.26-1.07-1.22.31-3.3.72-4.19.96,2.1,1.39,3.29,1.93,3.1,4.09-2.93-3.41-7.03-3.26-7.55-3.17-1.49.26-3.68,3.49-3.96,4.97,2.52-1,3.96-1.56,7.53,1.06-4.23-.94-7.24.7-11.41,1.88,4.42.27,5.08.82,9.32,2.07-4.36,2.36-3.31,3.04-4.96,6.47,3.81-1.16,9.28-8.2,12.01-6.4.99-1.05,8.34-1.83,10.07.2,4.48,5.27,2.5,4.42,5.42,5.85-.65-2.16,0-4.45-1.34-5.28.18-1.36,5.46.23,5.46.23Z"
      />
      <path
        style={{ fill: '#00cbd0' }}
        d="M8.56,19.29s4.5-1.53,6.5-1.67c1.74-.12,5.11-.38,6.64.33-.36-2.11-5.23-1.74-7.1-1.26-1.97.5-6.04,2.6-6.04,2.6Z"
      />
      <path
        style={{ fill: '#74b2fd' }}
        d="M29.58,11.67c.53-1.72.8-2.99,2.32-4-.37,1.77-.74,3.55-1.41,5.24-.26.65-1.72,3.96-2.67,4.01.78-2.1,1.47-4.32,1.75-5.24Z"
      />
      <polygon
        style={{ fill: '#fee9ee' }}
        points="21.52 37.1 21.44 36.65 23.53 35.96 26.48 36.45 26.63 36.82 24.04 37.72 21.52 37.1"
      />
      <path
        style={{
          fill: '#fa6fa6',
        }}
        d="M22.6,38.02c-.71-.17-1.33-.84-1.28-1.14.03-.16.61.32,2.7.31,1.53,0,2.51-.56,2.68-.48.2.09-.62,1.04-1.15,1.19-.87.23-1.87.4-2.95.13Z"
      />
      <path
        style={{ fill: '#db1d51' }}
        d="M21.3,36.74c.35-.76,1.66-1.24,2.61-1.23,1.4,0,2.53.66,2.87,1.18.11.18-1.26-.24-2.88-.22-1.48.01-2.81.73-2.6.28Z"
      />
    </g>
  </AvatarArtwork>
);
